import ColumnBase from "./ColumnBase.jsx";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {ColumnStore} from "@bryntum/schedulerpro";
import { CHECKLIST_STATE, ICON_COL_DEF_WIDTH } from "../../other/constants/OtherKeys.jsx";
import { defaultGroupRenderer, openGeneralWidgetFromGridRecord } from "../../other/utils/utils.jsx";
import { WIDGET_REGISTRY } from "../../other/constants/EntityManagerConfig.tsx";
import { HasIconColumnTooltipMixin } from "./mixins/HasIconColumnTooltipMixin.jsx";

const getChecklistIcon = (checklistStatus = CHECKLIST_STATE.NO_CHECKLIST) => {
  let checklistColor = "";
  if (checklistStatus === CHECKLIST_STATE.IN_COMPLETE) checklistColor = "text-[#dc7f00]";
  if (checklistStatus === CHECKLIST_STATE.ALL_CHECKED) checklistColor = "text-[#0a88e9]";
  return `<i class="swivu-checklist-icon-tooltip fa-regular fa-list-check ${checklistColor}"></i>`;
}

export default class ChecklistColumn extends HasIconColumnTooltipMixin(ColumnBase) {
  static get $name() {
    return "ChecklistColumn";
  }

  static get type() {
    return WIDGET_KEYS.checklistColumn;
  }

  static get defaults() {
    return {
      text: "Checklist",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      field: "checklistStatus",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      renderer({ value }) {
        return getChecklistIcon(value);
      },
      groupRenderer({ groupRowFor, ...rest }) {
        return defaultGroupRenderer({ groupRowFor: getChecklistIcon(groupRowFor), ...rest });
      },
      headerRenderer() {
        return getChecklistIcon();
      }
    }
  }

  getTooltipSelector() {
    return ".swivu-checklist-icon-tooltip";
  }

  getTooltipItems() {
    return [];
  }

  onSwivuColumnClick(e) {
    openGeneralWidgetFromGridRecord(this.editorHandler, e.record, WIDGET_REGISTRY.checklists.id);
  }
}

ColumnStore.registerColumnType(ChecklistColumn);
